module.exports = __webpack_public_path__ + "img/cube5.c72a9447.png";